import React from "react";

/**
 * Context to hold the current authorized user and its profile
 * @type {React.Context<null>}
 */
const AuthUserContext = React.createContext(null);

export default AuthUserContext;
